import { render, staticRenderFns } from "./AfaView.vue?vue&type=template&id=0e0c8d08"
import script from "./AfaView.vue?vue&type=script&lang=js"
export * from "./AfaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports